import {
  USER_MODIFY_BEGIN,
  USER_MODIFY_SUCCESS,
  USER_MODIFY_ERROR,
  USER_MODIFY_RESET,
} from './constants';

export const userModifyBegin = () => ({
  type: USER_MODIFY_BEGIN,
});

export const userModifySuccess = payload => ({
  type: USER_MODIFY_SUCCESS,
  payload,
});

export const userModifyError = payload => ({
  type: USER_MODIFY_ERROR,
  payload,
});

export const userModifyReset = () => ({
  type: USER_MODIFY_RESET,
});
